import { InvoiceEventType } from '../enums/invoiceEventType'

export const invoiceSentStatusEvents: InvoiceEventType[] = [
  InvoiceEventType.DeliveryBaswareEinvoiceSent,
  InvoiceEventType.DeliveryBaswarePaperSent,
  InvoiceEventType.DeliveryCreditnoteEmailSent,
  InvoiceEventType.DeliveryEmailSent,
  InvoiceEventType.DeliveryManualSent,
  InvoiceEventType.DeliveryPublicDeBaswareEinvoiceSent,
  InvoiceEventType.DeliveryPublicFrBaswareEinvoiceSent,
]
